/**
 * SpotlightSearch — Modal de recherche rapide (Ctrl+K) pour navigation.
 *
 * Extrait de Layout.js (P2 refactor Feb 2026) — comportement identique.
 */
import React from 'react';
import { MagnifyingGlass } from '@phosphor-icons/react';

export default function SpotlightSearch({
  open,
  onClose,
  query,
  onQueryChange,
  results,
  onGo,
  inputRef,
  lang,
}) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 bg-stone-900/60 backdrop-blur-sm z-[60] flex items-start justify-center pt-24 px-4"
      onClick={onClose}
      data-testid="spotlight-overlay"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-xl bg-white rounded-2xl shadow-2xl overflow-hidden"
        data-testid="spotlight-modal"
      >
        <div className="flex items-center gap-3 px-4 py-3 border-b border-stone-200">
          <MagnifyingGlass size={20} className="text-stone-400" />
          <input
            ref={inputRef}
            type="text"
            value={query}
            onChange={(e) => onQueryChange(e.target.value)}
            placeholder={lang === 'ar' ? 'اقفز إلى أي صفحة...' : 'Aller à une page... (clients, ventes, voyages...)'}
            className="flex-1 outline-none text-base bg-transparent placeholder:text-stone-400"
            data-testid="spotlight-input"
            onKeyDown={(e) => {
              if (e.key === 'Enter' && results.length > 0) {
                onGo(results[0].path);
              }
            }}
          />
          <kbd className="text-[10px] font-mono px-1.5 py-0.5 rounded bg-stone-100 text-stone-500 border border-stone-200">ESC</kbd>
        </div>
        <div className="max-h-96 overflow-y-auto p-2">
          {results.length === 0 ? (
            <div className="text-center text-stone-400 py-10 text-sm">
              {lang === 'ar' ? 'لا توجد نتائج' : 'Aucun résultat'}
            </div>
          ) : (
            results.map((it) => {
              const Icon = it.icon;
              return (
                <button
                  key={it.path}
                  type="button"
                  onClick={() => onGo(it.path)}
                  data-testid={`spotlight-result-${it.label.toLowerCase().replace(/\s+/g, '-')}`}
                  className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl hover:bg-sky-50 transition-colors text-left"
                >
                  <Icon size={18} className="text-sky-600 shrink-0" />
                  <span className="flex-1 text-sm font-medium text-stone-800 truncate">{it.label}</span>
                  <span className="text-xs text-stone-400 truncate">{it.path}</span>
                </button>
              );
            })
          )}
        </div>
        <div className="px-4 py-2 border-t border-stone-100 bg-stone-50/50 text-[11px] text-stone-500 flex items-center gap-3">
          <span><kbd className="font-mono px-1 py-0.5 rounded bg-white border border-stone-200">↵</kbd> Ouvrir</span>
          <span><kbd className="font-mono px-1 py-0.5 rounded bg-white border border-stone-200">Esc</kbd> Fermer</span>
        </div>
      </div>
    </div>
  );
}
